import { render, staticRenderFns } from "./RowInHostsBook.vue?vue&type=template&id=4f6a83c6&scoped=true"
import script from "./RowInHostsBook.vue?vue&type=script&lang=js"
export * from "./RowInHostsBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a83c6",
  null
  
)

export default component.exports